import { HTMLControl } from '../controls/html_control.js';
import { ReviewRatingsViewMarkup } from './review_ratings_view_markup.js';

import '../controls/collapsible_text.js';
import '../controls/rating_control.js';

class ReviewRatingsView extends HTMLControl {
  set(ratingsByGroups, attributes) {
    this.innerHTML = ReviewRatingsViewMarkup.getMarkupFor(
      ratingsByGroups,
      attributes
    );
  }

  static get selectors() {
    return ReviewRatingsViewMarkup.selectors;
  }

  static get elements() {
    let s = this.selectors;
    return {
      ratingGroupBy: groupId => s.RatingGroupBy(groupId),
      ratingControlBy: ratingId => s.RatingControlBy(ratingId),
    };
  }

  static tagName = 'review-ratings-view';
}

ReviewRatingsView.defineCustomElement();

export { ReviewRatingsView };
